module.exports = __webpack_public_path__ + "media/stylesheets/images/talentz/flow_img06-726837e0e94c0ac473e1adb885d92b7f.svg";